<template>
  <div>
    <header class="main-header">
      <div v-if="isMobile">
        <router-link to="/">
          <img
            :src="webInfo.websiteLogo"
            alt=""
            style="width: 120px;  background: #fff"
          />
        </router-link>
      </div>

      <el-menu
        v-else
        :default-active="toIndex"
        class="el-menu-demo"
        text-color="#000000"
        active-text-color="#3989fa"
        :mode="isMobile ? 'vertical' : 'horizontal'"
        @select="handleSelect"
        style="width: 80%"
      >
        <el-menu-item
          v-for="(item, index) in itemList"
          :index="item.path"
          :key="index"
          @click="openTab(item)"
          :style="{
            marginRight:
              item.title == '智能系统' || item.title == '智能产品'
                ? '-20px'
                : ''
          }"
        >
          <h1 v-if="item.title == '智起云'">
            <img
              :src="webInfo.websiteLogo"
              alt=""
              style="width: 150px; height: 40px; background: #fff"
            />
          </h1>
          <span v-else slot="title"
            >{{ item.title }}
            <i
              class="el-icon-arrow-down"
              :class="isActiveClass ? 'active-down' : 'el-icon-arrow-down'"
              v-if="item.title == '智能产品'"
            ></i>
            <i
              class="el-icon-arrow-down"
              :class="isActiveClass1 ? 'active-down1' : 'el-icon-arrow-down'"
              v-if="item.title == '智能系统'"
            ></i>
          </span>
        </el-menu-item>
      </el-menu>

      <div class="hd-right">
        <el-button type="text" @click="login">登录</el-button>
        <el-button size="small" type="primary" @click="login">
          立即注册
        </el-button>
        <div
          v-show="isMobile"
          style="margin-left: 10px;"
          @click="drawer = true"
        >
          <i class="el-icon-s-fold"></i>
        </div>
      </div>
    </header>

    <el-tabs
      type="border-card"
      tab-position="left"
      class="el-tabs-b"
      style="height: 500px; width: 70%"
      v-if="currentPage"
    >
      <el-tab-pane
        v-for="item in currentPage == 'smartProduct'
          ? tabPaneListObj.smartProduct
          : tabPaneListObj.smartSystem"
        :key="item.id"
        ><span slot="label" @click="choseTab(item)">
          <div class="tab-pane-title">
            <img :src="item.menuIcon" alt="" />
            <b>{{ item.menuTitle }}</b>
          </div>
          <p style="margin-top: -10px; color: #8a8b8d">{{ item.menuDes }}</p>
        </span>
        <div class="tab-content-c">
          <div>
            <el-button style="font-size: 20px" size="" type="text"
              >{{ item.menuTitle }} ></el-button
            >
            <div class="subpro">
              <div
                class="sub-item"
                v-for="(i, index) in item.subList"
                :key="i.index"
              >
                <div class="sub-item-t">
                  <img :src="i.subMenuIcon" alt="subMenuIcon" />
                  <el-button type="text" @click="proDetail(item, index)"
                    >{{ i.subMenuTitle }} ></el-button
                  >
                </div>
                <span>{{ i.subMenuDes }}</span>
              </div>
            </div>
          </div>
          <div class="video-list">
            <div
              class="videopro"
              v-for="video in item.videoList"
              :key="video.index"
            >
              <div class="video-item sub-item">
                <b>{{ video.videoTitle }}</b>
                <img :src="video.videoCover" alt="" @click="playVideo(video)" />
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-main style="padding: 0px !important">
      <router-view></router-view>
    </el-main>
    <el-dialog custom-class="video-style" :visible.sync="visible" width="35%">
      <i class="el-icon-circle-close" @click="close"></i>
      <video
        :src="videoUrl"
        width="100%"
        autoplay
        height="auto"
        controls
      ></video>
    </el-dialog>

    <el-drawer :visible.sync="drawer" size="250px">
      <el-menu
        :default-active="toIndex"
        unique-opened
        class="el-menu-demo"
        style="width: 100%;"
        text-color="#000000"
        active-text-color="#3989fa"
        mode="vertical"
        @select="handleSelect2"
        @open="openTab2"
      >
        <template
          v-for="(item, index) in itemList.filter(
            i => !['/buyService', '/webTemeplate'].includes(i.path)
          )"
        >
          <el-submenu
            v-if="item.title && ['智能系统', '智能产品'].includes(item.title)"
            :key="index"
            :index="item.title"
          >
            <template slot="title">
              <span>{{ item.title }}</span>
            </template>

            <el-submenu
              v-for="(i, subIndex) in tabPaneListObj[
                item.title === '智能系统' ? 'smartSystem' : 'smartProduct'
              ]"
              :key="index + subIndex"
              :index="index + subIndex + ''"
            >
              <template slot="title">{{ i.menuTitle }}</template>
              <el-menu-item
                v-for="(si, ssIndex) in i.subList"
                :index="[i.id, i.type, i.menuTitle, ssIndex].toString()"
                :key="index + i.menuTitle + ssIndex"
              >
                <span slot="title">
                  {{ si.subMenuTitle }}
                </span>
              </el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-menu-item v-else :key="index + 'else'" :index="item.path">
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-drawer>

    <footer-mes></footer-mes>
    <InvitCode />
  </div>
</template>

<script>
import FooterMes from "@/components/footerMes";
import InvitCode from "@/components/common/InvitCode";
export default {
  name: "NavMenu",
  components: {
    FooterMes,
    InvitCode
  },
  data() {
    return {
      drawer: false,
      isActiveClass: false,
      isActiveClass1: false,
      webInfo: {},
      title: "",
      visible: false,
      tabVisible: false,
      videoUrl: "",
      tabPaneList: [],
      itemList: [
        // 水平一级菜单栏的菜单
        { path: "/home", title: "智起云", icon: "kehuguanli-copy" },
        { path: "/", title: "智能产品" },
        { path: "", title: "智能系统" },
        { path: "/webTemeplate", title: "网站模板" },
        { path: "/buyService", title: "购买服务" },
        { path: "/news", title: "产品教程" },
        { path: "/aboutUs", title: "关于我们" }
      ],
      tabPaneListObj: {
        smartProduct: [],
        smartSystem: []
      },
      currentPage: ""
    };
  },
  computed: {
    toIndex() {
      // 根据路径绑定到对应的一级菜单，防止页面刷新重新跳回第一个
      return "/" + this.$route.path.split("/")[1];
    },
    isMobile() {
      return this.$store.state.app.isMobile;
    }
  },
  created() {
    this.$api.other.aboutUsShow().then(res => {
      this.webInfo = res.data;
    });
    this.getproInfo();
    this.getSystemInfo();
  },
  methods: {
    login() {
      window.open("https://saas.zhiqi-yun.com/zqsaas/login", "_blank");
    },
    choseTab(item) {
      if (item.subList == undefined && item.videoList == undefined) {
        this.proDetail(item);
      }
    },
    proDetail(item, index = 0) {
      if (this.title == "智能产品") {
        this.$router.push({
          path: "/smartProduct?id=" + item.id + "#" + "sec" + (index + 1)
        });
      } else if (this.title == "智能系统") {
        this.$router.push({
          path: "/smartSystem?id=" + item.id + "#" + "sec" + (index + 1)
        });
      }
      this.currentPage = "";
    },
    openTab(val) {
      if (!["智能产品", "智能系统"].includes(val.title)) return;
      this.title = val.title;
      if (
        this.currentPage ==
        (val.title == "智能产品" ? "smartProduct" : "smartSystem")
      ) {
        this.currentPage = "";
        this.tabVisible = false;
        return;
      }
      this.currentPage =
        val.title == "智能产品" ? "smartProduct" : "smartSystem";
      this.tabVisible = true;
    },
    openTab2(val) {
      if (val == "智能产品") {
        if (this.tabPaneListObj.smartProduct.length) return;
        this.getproInfo();
      } else if (val == "智能系统") {
        if (this.tabPaneListObj.smartSystem.length) return;
        this.getSystemInfo();
      }
    },
    close() {
      this.visible = false;
    },
    playVideo(val) {
      this.visible = true;
      this.videoUrl = val.videoLink;
    },
    getSystemInfo() {
      this.$api.smartSystem.systemList().then(async res => {
        this.tabPaneList = res.data.list.map(i => {
          return {
            ...i,
            type: "智能系统"
          };
        });

        this.$set(this.tabPaneListObj, "smartSystem", this.tabPaneList);
        await this.$nextTick();
      });
    },
    getproInfo() {
      this.$api.productManagement.proList().then(async res => {
        this.tabPaneList = res.data.list.map(i => {
          return {
            ...i,
            type: "智能产品"
          };
        });
        this.$set(this.tabPaneListObj, "smartProduct", this.tabPaneList);
        await this.$nextTick();
      });
    },
    handleSelect(path) {
      if (!path || path == "/") return;
      this.drawer = false;
      // 切换菜单栏
      this.$router.push({
        path: path
      });
    },
    handleSelect2(path) {
      if (path.indexOf("/") !== -1) {
        this.$router.push({
          path
        });
        this.drawer = false;
        return;
      }
      const item = path.split(",");
      this.drawer = false;
      // 切换菜单栏
      this.$router.push({
        path:
          (item[1] === "智能产品" ? "/smartProduct" : "smartSystem") +
          "?id=" +
          item[0] +
          "#sec" +
          (item[3] * 1 + 1)
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.main-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  box-sizing: border-box;
  background-color: #fff;
  z-index: 99;
}
.header {
  position: fixed;
  width: 100%;
  z-index: 99;
  background-color: #fff;
  padding: 0 20px;
  box-sizing: border-box;
}
.active-down {
  transform: rotate(180deg);
}
.active-down1 {
  transform: rotate(180deg);
}
.nav-menu {
  .header {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
}
.tab-pane-title {
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
  b {
    color: #2e2f32;
    font-size: 16px;
    font-weight: bold;
  }
}
.tab-content-c {
  // width: 70%;
  font-size: 14px;
  p {
    color: #2e3034;
    padding: 20px 0;
  }
  span {
    color: #8a8c90;
  }
  .subpro {
    padding-right: 80px;
    height: 220px;
    border-top: 1px solid #d8dee3;
    display: flex;
    justify-content: flex-start;
    .sub-item {
      margin: 0 20px;
      width: 27%;
      .sub-item-t {
        display: flex;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
      }
    }
  }
  .video-list {
    border-top: 1px solid #d8dee3;
    display: flex;
    justify-content: flex-start;
    padding: 15px 0;
    .videopro {
      display: flex;
      width: 30%;
      .video-item {
        display: flex;
        flex-direction: column;
        img {
          width: 220px;
          height: 130px;
          cursor: pointer;
        }
        b {
          padding: 10px 0;
        }
      }
    }
  }
}

.el-tabs-b /deep/ .el-tabs,
.el-tabs--left {
  position: absolute;
  top: 60px;
  left: 200px;
  z-index: 10;
}
.el-tabs-b /deep/.el-tabs__nav-scroll,
.is-left {
  background: #f5f6f9;
}
.el-tabs-b /deep/.el-tabs__item.is-active {
  background: #fff;
}
.el-tabs-b /deep/ .el-tabs__nav-wrap {
  padding: 0 !important;
}
.el-tabs-b /deep/.el-tabs__item {
  height: 90px;
  padding: 10px 40px;
}
/deep/ .el-menu-demo .el-menu--horizontal .el-menu {
  border-bottom: 1px solid #333 !important;
}
/deep/ .video-style {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    background-color: transparent;
  }
}
.el-icon-circle-close {
  position: absolute;
  font-size: 20px;
  top: -10px;
  right: 0px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
}

.hd-right {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/NavMenu.vue